import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class ArtikelSlider extends HTMLElement {
    constructor() {
        super();
        this.scrollButtons = null;
    }

    connectedCallback() {
        const liste = this.querySelector('.tm-produktliste');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();
    }
    
    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }
}

if (!customElements.get("slider-artikel")) {
    customElements.define("slider-artikel", ArtikelSlider);
}
